import axios from "axios";

export const updatePasswordUser = async (
  idusuario,
  current,
  newPassword,
  newPasswordConfirmation,
) => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}users/${idusuario}`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  try {
    const response = await axios.patch(
      apiUrlDashboard,
      {
        updated_at: new Date().toISOString(),
        current_password: current,
        new_password: newPassword,
        new_password_confirmation: newPasswordConfirmation,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};

export const updateUserProfile = async (idusuario, userData) => {
  const token = localStorage.getItem("token");
  const apiUrlDashboard = `${process.env.REACT_APP_API}users/${idusuario}`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  try {
    const response = await axios.put(
      apiUrlDashboard,
      {
        updated_at: new Date().toISOString(),
        first_name: userData.first_name,
        last_name: userData.last_name,
        email: userData.email,
        car: userData.car,
        championship: userData.championship,
        bio: userData.bio,
        phone_number: userData.phone_number,
        color_session: userData.color_session,
        color_reference: userData.color_reference,
        contacts: userData.contacts,
        won_championships: userData.won_championships,
        unread_messages: userData.unread_messages,
        subscription_expire_date: userData.subscription_expire_date,
        data_sources: userData.data_sources,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};
